'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-extraneous-dependencies */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _core = require('@material-ui/core');

var _IconButton = require('@material-ui/core/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Typography = require('../Typography');

var _button = require('../../schema/component/button.json');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = exports.Button = function Button(props) {
  var children = props.children,
      className = props.className,
      disabled = props.disabled,
      fullWidth = props.fullWidth,
      size = props.size,
      textVariant = props.textVariant,
      type = props.type;

  var typeButton = _button.properties[type];
  var textAlign = fullWidth ? 'center' : 'left';

  // IF Button Type Not Found
  if (!typeButton) {
    return _react2.default.createElement(
      _core.Button,
      _extends({
        'data-disabled': disabled,
        'data-size': size,
        disabled: disabled
      }, props, {
        className: 'btn ' + className
      }),
      _react2.default.createElement(
        _Typography.Typography,
        {
          className: 'button-text',
          variant: textVariant,
          'data-text-align': textAlign
        },
        children
      )
    );
  }

  // IF Icon Button
  if (type.includes('icon')) {
    return _react2.default.createElement(
      _IconButton2.default,
      _extends({
        'data-color': typeButton.properties.color,
        'data-disabled': disabled,
        'data-size': size,
        disabled: disabled
      }, props, {
        className: 'btn-icon ' + className
      }),
      children
    );
  }

  // IF Not Icon Button
  if (!type.includes('icon')) {
    return _react2.default.createElement(
      _core.Button,
      _extends({
        'data-background': typeButton.properties.background,
        'data-color': typeButton.properties.color,
        'data-disabled': disabled,
        'data-outline': typeButton.properties.outline,
        'data-size': size,
        disabled: disabled
      }, props, {
        className: 'btn ' + className
      }),
      _react2.default.createElement(
        _Typography.Typography,
        {
          className: 'button-text',
          variant: textVariant,
          'data-text-align': textAlign
        },
        children
      )
    );
  }

  return null;
};

Button.defaultProps = {
  className: '',
  disabled: false,
  fullWidth: false,
  size: 'medium',
  textVariant: 'textbutton',
  type: 'contained-primary'
};

Button.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node, _propTypes2.default.string, _propTypes2.default.number]).isRequired,
  disabled: _propTypes2.default.bool,
  fullWidth: _propTypes2.default.bool,
  size: _propTypes2.default.string,
  textVariant: _propTypes2.default.string,
  type: _propTypes2.default.string
};

exports.default = Button;